import { Path } from 'slate';

export interface BlockCarrier {
  path: Path;
  elementId: string;
}

export interface BlockSelection {
  kind: 'image' | 'table' | 'paragraph' | 'list';
  path: Path;
  elementId: string;
}

export function selectionBlockCarrier(blockSelection: BlockSelection | null, blockScope: string | undefined): BlockCarrier | null {
  if (!blockSelection) return null;
  const { kind, path, elementId } = blockSelection;
  if (kind === 'image') return { path, elementId };
  if ((kind === 'paragraph' || kind === 'list') && blockScope === 'block') return { path, elementId };
  return null;
}
